/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";

/** Components */
import { FilterBy } from "./../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import LoadingProgress from "../../commons/LoadingProgress.component";
import { TreeMenu } from "./../../commons/renderTreeMenu.component";

/**Icons */
import AssessmentIcon from "@mui/icons-material/Assessment";
import SearchIcon from "@mui/icons-material/Search";
import { TableContainer, Paper, Table, TableRow, TableHead, TableCell, TableBody, TablePagination, TableFooter, Button, TextField, Tabs, Tab, Collapse, ButtonGroup, Tooltip } from "@mui/material";

/** Api */
import { getCustomers, getDebt, getDebtMenu } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/**Package */
import moment from "moment";

/** Hook */
import { useParamFilter } from "./../../commons/customHook";
import { Link, useHistory } from "react-router-dom";
import { statusColor } from "../../config";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const initialInput = {
  selectedCustomer: null,
  start_date: "",
  end_date: "",
  tp_code: "",
};

export default function Debt() {
  const history = useHistory();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { fetchData, responseData, filter, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 25, type: "CRRT" }, getDebt);

  // state
  const [treeData, setTreeData] = useState();
  const [isSearchOpen, setSearchOpen] = useState(true);
  const [input, setInput] = useState({ ...initialInput, start_date: filter.start_date || "", end_date: filter.end_date || "" });
  const [selectedRow, setSelectedRow] = useState();
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, type: filter.type, selectedCustomer: undefined, customer_id: input.selectedCustomer?.id }));
    setTreeData(null);
    getDebtMenu().then((res) => {
      setTreeData(res.data);
    });
  };
  const handleChangeTab = (e, newValue) => {
    setInput({ ...initialInput });
    fetchData((prev) => ({ type: newValue }));
    setSelectedRow();
    setTreeData(null);
    getDebtMenu().then((res) => {
      setTreeData(res.data);
    });
  };

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN KHÁCH HÀNG THANH TOÁN"));
    fetchData(filter);
    setTreeData(null);
    getDebtMenu().then((res) => {
      setTreeData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#b3deff", marginBottom: 10, marginTop: 10, height: 40 }}>
        <Tabs value={filter.type || "CRRT"} onChange={handleChangeTab} style={{ height: 40 }}>
          <Tab label={t("Chưa thanh toán")} value="CRRT" />
          <Tab label={t("Tất cả giao dịch")} value="ALL" />
        </Tabs>
        <ButtonGroup style={{ height: 40 }}>
          <Button onClick={() => history.push("/report/debt")} title="Xem báo cáo">
            <Tooltip title="Báo cáo tổng kết nợ của khách hàng">
              <AssessmentIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        {/* filter */}
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.selectedCustomer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedCustomer: newValue }))}
          label={t("Khách hàng")}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, selectedCustomer: option.find((item) => item.id == filter.customer_id) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[filter.customer_id]}
        />
        <TextField
          variant="outlined"
          label={t("Mã chứng từ")}
          value={input.tp_code || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, tp_code: e.target.value }))}
          style={{ margin: "5px" }}
          InputProps={{ style: { minWidth: "200px" } }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Từ ngày")}
          value={input.start_date}
          onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Đến ngày")}
          value={input.end_date}
          onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <Button onClick={handleSearch} style={{ margin: "5px" }} variant="outlined">
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      <div style={{ display: "flex" }}>
        <TreeMenu
          data={treeData}
          onClick={(query) => {
            fetchData((prev) => ({ ...query, type: prev.type, per_page: prev.per_page }));
            setInput({});
          }}
          isExpand={!isSearchOpen}
          onExpand={() => setSearchOpen(false)}
        />
        {loading ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                {responseData?.cus_debt?.map((i, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" style={{ fontWeight: 600, background: "lightblue" }} colSpan={50}>
                      Tổng tiền cần thanh toán ({i.currency}): {i.total.toLocaleString(i.currency === "VND" ? "de-DE" : "ja-JP", { minimumFractionDigits: i.currency === "USD" ? 2 : 0 })}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("STT")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Khách hàng")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Mã chứng từ")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Ngày chứng từ")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Hạn thanh toán")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Tiền tệ")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Tổng tiền")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Số tiền còn lại")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Ngày thanh toán")}
                  </TableCell>
                  {/* <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Mã chứng từ thu")}
                  </TableCell> */}
                  <TableCell style={{ border: "1px solid lightgray", backgroundColor: "#f0f3f5" }} align="center">
                    {t("Trạng thái")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length ? (
                  data.map((item, index) => (
                    <React.Fragment key={index}>
                      <TableRow onClick={() => setSelectedRow((prev) => (prev === index ? -1 : index))} hover style={{ cursor: "pointer" }} key={index}>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.customer_name}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="left">
                          {item.tp_code}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.tp_date && moment(item.tp_date).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.tp_duedate && moment(item.tp_duedate).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.currency}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.gl_db?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="right">
                          {item.debt?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}
                        </TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.gl_db > item.debt && item.ptp_date && moment(item.ptp_date).format("DD/MM/YYYY")}
                        </TableCell>
                        {/* <TableCell style={{ border: "1px solid lightgray" }} align="center">
                          {item.erppts_id}
                        </TableCell> */}
                        <TableCell style={{ border: "1px solid lightgray" }}>
                          <div className={`status ${item.status}`} style={{ color: statusColor[item.status] }}>
                            {t(item.status)}
                          </div>
                        </TableCell>
                      </TableRow>
                      {selectedRow === index && (
                        <>
                          {item.ptrans?.length ? (
                            item.ptrans.map((sub_item, sub_index) => (
                              <TableRow component={Link} target="_blank" to={`/erppt/${sub_item.erppts_id}`} style={{ backgroundColor: "#f2f2f3" }} key={`${index}.${sub_index}`}>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {index + 1}.{sub_index + 1}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="left">
                                  {sub_item.customer_name}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="left">
                                  {sub_item.tp_code}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {sub_item.tp_date && moment(sub_item.tp_date).format("DD/MM/YYYY")}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {sub_item.tp_duedate && moment(sub_item.tp_duedate).format("DD/MM/YYYY")}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {sub_item.currency}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="right">
                                  {sub_item.gl_db?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="right">
                                  {sub_item.gl_cr?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {sub_item.ptp_date && moment(sub_item.ptp_date).format("DD/MM/YYYY")}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} component="div" align="center">
                                  {sub_item.erppts_id}
                                </TableCell>
                                <TableCell style={{ border: "1px solid lightgray" }} align="center"></TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell align="center" colSpan={20}>
                                {t(isAllow ? "Không có dữ liệu" : "No permission")}
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
}
